import { render, staticRenderFns } from "./CalendarCardItem.vue?vue&type=template&id=c597dfc6&scoped=true"
import script from "./CalendarCardItem.vue?vue&type=script&lang=js"
export * from "./CalendarCardItem.vue?vue&type=script&lang=js"
import style0 from "./CalendarCardItem.vue?vue&type=style&index=0&id=c597dfc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c597dfc6",
  null
  
)

export default component.exports